import { useCallback, useState } from 'react'

export interface UseToggleProps {
    initialState?: boolean
}

export const useToggle = (args?: UseToggleProps) => {
    const initialToggleState =
        args?.initialState !== undefined ? args.initialState : false
    const [active, setActive] = useState(initialToggleState)

    const toggleOff = useCallback(() => {
        setActive(false)
    }, [])

    const toggleOn = useCallback(() => {
        setActive(true)
    }, [])

    const toggle = useCallback(() => {
        setActive((active) => !active)
    }, [])

    return {
        active,
        toggle,
        toggleOff,
        toggleOn
    }
}
